/* global wp */
import classNames from 'classnames';
import TextInput from './text-input';

const { __ } = wp.i18n;
const { useState } = wp.element;

const PasswordField = (props) => {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<div className="sui-with-button sui-with-button-icon">
			<TextInput
				type={showPassword ? 'text' : 'password'}
				autoComplete="off"
				{...props}
			/>
			<button
				className="sui-button-icon"
				type="button"
				onClick={() => setShowPassword(!showPassword)}
			>
				<span
					className={classNames({
						'sui-icon-eye': !showPassword,
						'sui-icon-eye-hide': showPassword,
					})}
					aria-hidden="true"
				></span>
				<span className="sui-password-text sui-screen-reader-text">
					{showPassword
						? __('Hide Password', 'wpmudev')
						: __('Show Password', 'wpmudev')}
				</span>
			</button>
		</div>
	);
};

export default PasswordField;
